/**
 * Навигация и заголовки страниц.
 *
 * Собраны вместе, чтобы пункт меню и заголовок экрана не расходились в
 * названиях: раньше «Правила» в меню вели на страницу «Правила качества».
 */

export interface Crumb {
  label: string;
  href?: string;
}

export interface PageMeta {
  title: string;
  breadcrumb: Crumb[];
}

const ROOT: Crumb = { label: 'callog.kz' };

/**
 * Заголовок и хлебные крошки по адресу.
 *
 * Считаются из пути, а не передаются страницей: макет теперь общий и живёт
 * выше страниц, а гонять эти две строки через контекст ради статичных
 * значений — лишний слой, который к тому же мигал бы старым заголовком на
 * один кадр при каждом переходе.
 */
export function pageMeta(pathname: string): PageMeta {
  if (pathname.startsWith('/call-detail')) {
    return {
      title: 'Карточка звонка',
      breadcrumb: [ROOT, { label: 'Звонки', href: '/call-list' }, { label: 'Карточка' }],
    };
  }
  if (pathname.startsWith('/missed-calls')) {
    return { title: 'Пропущенные', breadcrumb: [ROOT, { label: 'Пропущенные' }] };
  }
  if (pathname.startsWith('/call-list')) {
    return { title: 'Звонки', breadcrumb: [ROOT, { label: 'Звонки' }] };
  }
  if (pathname.startsWith('/dashboard')) {
    return { title: 'Дашборд', breadcrumb: [ROOT, { label: 'Дашборд' }] };
  }
  if (pathname.startsWith('/reports')) {
    return { title: 'Отчёты', breadcrumb: [ROOT, { label: 'Отчёты' }] };
  }
  if (pathname.startsWith('/directories')) {
    return { title: 'Справочники', breadcrumb: [ROOT, { label: 'Справочники' }] };
  }
  if (pathname.startsWith('/notifications')) {
    return { title: 'Оповещения', breadcrumb: [ROOT, { label: 'Оповещения' }] };
  }
  if (pathname.startsWith('/contacts')) {
    // Раздел теперь свой: заходят и из звонка, и прямо из меню, поэтому
    // крошка ведёт в «Клиентов», а не обратно в журнал звонков.
    return {
      title: 'Клиенты',
      breadcrumb: [ROOT, { label: 'Клиенты' }],
    };
  }
  if (pathname.startsWith('/platform')) {
    return { title: 'Клиенты платформы', breadcrumb: [ROOT, { label: 'Клиенты платформы' }] };
  }
  if (pathname.startsWith('/servers')) {
    return { title: 'Станции АТС', breadcrumb: [ROOT, { label: 'Станции АТС' }] };
  }
  if (pathname.startsWith('/access')) {
    return { title: 'Доступ', breadcrumb: [ROOT, { label: 'Доступ' }] };
  }
  if (pathname.startsWith('/calltracking')) {
    return { title: 'Коллтрекинг', breadcrumb: [ROOT, { label: 'Коллтрекинг' }] };
  }
  if (pathname.startsWith('/integrations')) {
    return { title: 'Интеграции', breadcrumb: [ROOT, { label: 'Интеграции' }] };
  }
  if (pathname.startsWith('/quality-rules')) {
    return { title: 'Настройка разбора', breadcrumb: [ROOT, { label: 'Настройка разбора' }] };
  }
  return { title: 'callog.kz', breadcrumb: [ROOT] };
}
